module.exports = __webpack_public_path__ + "static/cliente_13-43f919e11e7eb7cdf3de2c7031b082b9.png";